import React from 'react';
import { FieldSheet } from '../../types/types';
import Template from './Template';
import TemplateMX from './TemplateMX';
import { StoreStateContext } from '../../context/Store/StoreProvider';

export interface FieldSheetLetterProps {
  fieldSheets?: FieldSheet[];
  classes?: any;
}

// This has to be class component, in order to integrate with react-to-print
class ComponentToPrint extends React.Component<FieldSheetLetterProps> {
  static contextType = StoreStateContext;
  render() {
    const { fieldSheets } = this.props;
    const { isMXAccountManagement } = this.context;

    return (
      <div>
        {isMXAccountManagement
          ? fieldSheets?.map((sheet: FieldSheet, index: number) => (
              <TemplateMX
                key={index}
                fieldSheet={sheet}
                totalFieldSheets={fieldSheets?.length ? fieldSheets?.length : 0}
                fieldSheeNum={index ? index : 0}
              />
            ))
          : fieldSheets?.map((sheet: FieldSheet, index: number) => (
              <Template
                key={index}
                fieldSheet={sheet}
                totalFieldSheets={fieldSheets?.length ? fieldSheets?.length : 0}
                fieldSheeNum={index ? index : 0}
              />
            ))}
      </div>
    );
  }
}

export default ComponentToPrint;
